module.exports = __webpack_public_path__ + "img/support_d5.18ee7914.png";